import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Check, CalendarDays, Building2, User, UserCircle } from 'lucide-react';
import { SuccessDialogProps } from '../@types/props.types';
import { formatDateWithTime } from '@/utils/dateFormatters';

const SuccessDialog = ({
  isOpen,
  onClose,
  selectedClass,
  clubNames,
  userName,
}: SuccessDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="rounded-lg overflow-hidden p-0 sm:max-w-[425px]">
        <div className="flex items-center justify-center bg-primary/10 p-6">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
            <Check className="h-8 w-8 text-primary" />
          </div>
        </div>
        <div className="p-6">
          <DialogHeader>
            <DialogTitle className="rounded-lg mb-2 text-center text-xl">
              Занятие успешно отменено
            </DialogTitle>
            <DialogDescription className="text-center text-base">
              <div className="space-y-4">
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <CalendarDays className="h-5 w-5" />
                  <span>{formatDateWithTime(selectedClass?.start_date)}</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <Building2 className="h-5 w-5" />
                  <span>АкваСтар {clubNames[selectedClass?.club_id]}</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <User className="h-5 w-5" />
                  <span>Инструктор: {selectedClass?.employee?.name}</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <UserCircle className="h-5 w-5" />
                  <span>Ребенок: {userName}</span>
                </div>
              </div>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-8">
            <Button onClick={onClose} className="w-full" size="lg">
              Готово
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
